import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(ApplicationService) {
        this.ApplicationService = ApplicationService;
    }

    $onInit() {
        this.applicationId = this.resolve.application.id;
		this.applicationName=this.resolve.application.applicationName;
		this.credentials={username:'',password:''};
		this.showPassword =false;
    }

    save() {
	console.log(this.applicationId);
        this.ApplicationService.registerAccount({appid: this.applicationId },this.credentials)
           // .save(this.applicationId, this.accountId, this.config)
            .$promise.then((response) => this.close({$value: response}))
            .catch((response) => this.spAlert = new SpAlert('danger', response.data.message));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/account-register/account-register.controller.js